module.exports = __webpack_public_path__ + "5799ad4c126b0a6b1a3f01599f862ad2.svg";